import { createSelector } from 'reselect';

import { AppState } from '../../types';
import {
  StateListArticles,
  UploadMediaState,
  StateForms,
  MediaViewerState,
  MediaExportState, FormArticle,
} from './types';
import { DocumentPage, StateDocumentPages } from './types/documentPages';

export const selectArticles = (state: AppState): StateListArticles => state.articles.list;

export const selectUploadMedia = (state: AppState): UploadMediaState => state.articles.uploadMedia;

export const selectArticleForms = (state: AppState): StateForms => state.articles.forms;

export const selectMediaViewer = (state: AppState): MediaViewerState => state.articles.mediaViewer;

export const selectMediaExport = (state: AppState): MediaExportState => state.articles.mediaExport;

export const selectArticlesMediaSubmitState = (state: AppState): boolean => state.articles.forms.isSubmit;

export const selectArticlesMediaFormsState = (state: AppState): FormArticle[] | null => state.articles.forms.forms;

export const selectArticlesFormDirty = createSelector(
  selectArticlesMediaSubmitState,
  selectArticlesMediaFormsState,
  (submitState, articleForms): boolean => {
    const isDirtyForms = (articleForms?.length && articleForms.some((form) => form.isChange)) || false;
    return submitState || isDirtyForms;
  },
);

export const selectArticleForm = (id: number) => createSelector(
  selectArticleForms,
  (state) => (state.forms ? state.forms.find((item) => item.id === id) : null),
);

export const selectUploadMediaById = (id: number) => createSelector(
  selectUploadMedia,
  (state) => {
    return state.uploads.find((upload) => upload.article.id === id);
  },
);

export const selectCurrentDocumentPageIndex = (state: AppState): number => state
  .articles.mediaViewer.currentDocumentPageIndex;

export const selectDocumentPage = (state: AppState): StateDocumentPages => state.articles.documentPages;

export const selectDocumentPageList = (state: AppState): DocumentPage[] | null => state.articles.documentPages.data;

export const selectCurrentDocumentPage = (state: AppState): DocumentPage | null => state.articles.documentPages.current;

export const uploadMediaFromUrlState = (state: AppState) => state.articles.uploadMediaFromUrl;

export const selectHaveUploadMedia = (state: AppState) => {
  const articles = state.articles.list.data?.items || [];
  const haveUploadVideo = articles.some((article) => article.ref?.video?.ref.is_uploading || false);
  const haveUploadDocument = articles.some((article) => article.ref?.document?.ref.is_uploading || false);

  return haveUploadVideo || haveUploadDocument;
};
